import api, { fmtEUR, fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export function DeleteTxDialog({ tx, onClose, onDeleted }) {
  const deleteTx = async () => {
    try {
      await api.delete(`/banks/transactions/${tx.id}`);
      toast.success("Movimiento eliminado");
      onClose();
      onDeleted();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al eliminar");
      onClose();
    }
  };

  return (
    <Dialog open={!!tx} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="tx-delete-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Eliminar movimiento de caja</DialogTitle>
          <DialogDescription>Solo para movimientos de efectivo introducidos por error. La eliminación queda registrada en auditoría y no se puede deshacer.</DialogDescription>
        </DialogHeader>
        {tx && (
          <div className="space-y-4">
            <div className="text-sm text-slate-600">
              <strong>{tx.concept}</strong> · {fmtDate(tx.date)} · <span className="font-num">{fmtEUR(tx.amount)}</span>
            </div>
            <div className="flex justify-end gap-2">
              <Button variant="outline" data-testid="tx-delete-cancel" onClick={onClose}>Cancelar</Button>
              <Button data-testid="tx-delete-confirm" className="bg-red-600 hover:bg-red-700 text-white" onClick={deleteTx}>Eliminar</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
